import { ReactNode, useState } from 'react';
import styled from 'styled-components';
import { Flex } from '../Flex';
import { OutsideClicker } from '../OutsideClicker';

const IconButton = styled.i<{disabled?:boolean}>`
  font-size: ${({ theme }) => theme.fontSize[2]};
  color: ${({ theme }) => theme.colours.neutral[2]};
`;

export const MenuWrapper = styled(Flex)`
  position: relative;
  height: 100%;
  align-items:center;
  justify-content:center;
`;

export const MenuPopup = styled.div<{ show: boolean }>`${({ theme, show }) => `
  position: relative;
  z-index:9999;
  display: ${show ? 'flex' : 'none'};
  flex-direction: column;
  top: -${theme.padding[2]};
  right: ${theme.padding[3]};
  box-shadow: ${theme.boxShadow[1]};
  border-radius: ${theme.borderRadius[1]};
  padding-top: ${theme.padding[2]};
  padding-bottom: ${theme.padding[2]};
  background: ${theme.primary};
`}`;

export const TableMenuItem = styled.div`${({ theme }) => `
  padding: ${theme.padding[1]} ${theme.padding[2]};
  :hover {
    background-color: ${theme.colours.secondary[6]};
    cursor: pointer;
  }
`}`;

type MenuActionsProps = {
  children: ReactNode,
  id: string;
  disabled?: boolean;
}

export function TableMenuActions({
  id, disabled = false, children,
}: MenuActionsProps) {
  const [isShowMenu, toggleShowMenu] = useState<boolean>(false);

  return (
    <MenuWrapper>
      <IconButton
        id={`${id}-options`}
        className="mi-options-vertical"
        onClick={() => toggleShowMenu(true)}
        disabled={disabled}
      />
      {!disabled && (
        <OutsideClicker
          onClickOutside={() => toggleShowMenu(false)}
        >
          <MenuPopup
            show={isShowMenu}
          >
            {children}
          </MenuPopup>
        </OutsideClicker>
      )}
    </MenuWrapper>
  );
}
